import React from 'react';
import CongratulationFunctional from './Components/congratulationfunctional';
import reducer from './reducer';
import sagas from './sagas';
import { withReducer } from '@store/reducerLoader';

const CongratulationPage = ({ buttonMode, buttonName }) => {
	return <CongratulationFunctional buttonMode={buttonMode} buttonName={buttonName} />;
};
const ReducedScreen = withReducer('CongratulationPage', reducer, sagas)(CongratulationPage);
export default ReducedScreen;
